import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../../actions/application";
import { APPLICATION_CONTEXTS } from "../../../constants";
import "./styles.css";

class PopupMenu extends Component {
  /**************
   * Properties *
   **************/

  /**
   * The component's current state.
   *
   * @property {object}  state
   * @public
   *
   **/
  state = {
    visible: false,
    highlightIndex: 0,
  };

  buttonId = "popupMenuButton";

  /*********************
   * Protected methods *
   *********************/

  setVisibilityState = (isVisible) => this.setState({ visible: isVisible });

  toggleApplicationContext = () => {
    let newContext = APPLICATION_CONTEXTS.SERVICES;
    if (!this.state.visible) {
      if (this.props.buttonText === APPLICATION_CONTEXTS.QUICK_LINKS) {
        newContext = APPLICATION_CONTEXTS.QUICK_LINKS;
      } else if (this.props.buttonText === APPLICATION_CONTEXTS.BRANDING) {
        newContext = APPLICATION_CONTEXTS.BRANDING;
      } else if (this.props.buttonText === APPLICATION_CONTEXTS.PATIENT) {
        newContext = APPLICATION_CONTEXTS.PATIENT;
      } else if (this.props.buttonText === APPLICATION_CONTEXTS.THEME) {
        newContext = APPLICATION_CONTEXTS.THEME;
      }
    }
    this.props.actions.toggleMenuContext(newContext);
  };

  /**
   * Click handler.
   *
   * @protected
   *
   **/
  handleOnClick = () => this.toggleApplicationContext();

  handleMouseClick = (event) => {
    if (event.target.id !== this.buttonId) {
      this.props.actions.toggleMenuContext(APPLICATION_CONTEXTS.SERVICES);
    }
  };

  handleMouseOver = (event) =>
    this.setState({ highlightIndex: parseInt(event.target.dataset.index, 10) });

  performSleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  /**
   * Switches to the SERVICES context after sleeping a set amount of time.
   *
   * This function quickly solves an issue with the Enter key being processed by both the popup menu
   * and the mounted service when it should only be processed by the popup menu.
   *
   * @param {int} ms
   */
  async switchToServicesContext(ms) {
    await this.performSleep(ms);
    this.props.actions.toggleMenuContext(APPLICATION_CONTEXTS.SERVICES);
  }

  handleOnKeyUp(event) {
    let currentIndex;
    switch (event.key.toLowerCase()) {
      case this.props.hotkey:
        this.toggleApplicationContext();
        break;
      case "arrowup":
        if (this.props.context === this.props.buttonText) {
          currentIndex = this.state.highlightIndex;
          --currentIndex;
          if (currentIndex < 0) {
            currentIndex = this.props.menuLinks.length - 1;
          }
          this.setState({ highlightIndex: currentIndex });
        }
        break;
      case "arrowdown":
        if (this.props.context === this.props.buttonText) {
          currentIndex = this.state.highlightIndex;
          ++currentIndex;
          if (currentIndex > this.props.menuLinks.length - 1) {
            currentIndex = 0;
          }
          this.setState({ highlightIndex: currentIndex });
        }
        break;
      case "enter":
        if (this.props.context === this.props.buttonText) {
          let linkDestination = this.props.menuLinks[this.state.highlightIndex]
            .link;
          if (linkDestination && linkDestination !== "#") {
            this.props.history.push(linkDestination);
          } else {
            this.props.menuLinks[this.state.highlightIndex].action();
          }
          this.switchToServicesContext(50);
        }
        break;
      default:
    }
  }

  /*********************
   * Lifecycle methods *
   *********************/

  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp.bind(this), false);
    document.addEventListener("click", this.handleMouseClick, false);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.context !== this.props.context) {
      this.setVisibilityState(nextProps.context === this.props.buttonText);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp.bind(this));
    document.removeEventListener("click", this.handleMouseClick);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    let linkItems = this.props.menuLinks.map((menuLink, index) => {
      let linkClass = this.state.highlightIndex === index ? "selected" : "";
      if (menuLink.action) {
        return (
          <div
            data-index={index}
            key={index}
            onMouseUp={menuLink.action}
            onMouseOver={this.handleMouseOver}
            className={linkClass}
          >
            {menuLink.text}
          </div>
        );
      } else {
        return (
          <Link
            to={menuLink.link}
            data-index={index}
            key={index}
            onMouseOver={this.handleMouseOver}
            className={linkClass}
          >
            {menuLink.text}
          </Link>
        );
      }
    });
    return (
      <div
        className="dropdown"
        style={{ top: `${this.props.top}px`, left: `${this.props.left}px` }}
      >
        <button
          id={this.buttonId}
          onMouseUp={this.handleOnClick}
          className="popup-menu-button"
        >
          {this.props.buttonText}
        </button>
        <div
          className={`dropdown-content ${
            this.state.visible ? "dropdown-visible" : "dropdown-hidden"
          }`}
        >
          {linkItems}
        </div>
      </div>
    );
  }
}

const ConnectedPopupMenu = connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(PopupMenu);

export default withRouter(ConnectedPopupMenu);
